import { RouteLocationNormalized } from 'vue-router';
import { GateRedirect, normalizeGateValue, resolveEntitlementGate } from './gate';

class Feature implements Middleware {
    name(): string {
        return 'feature';
    }

    async run(to: RouteLocationNormalized): Promise<GateRedirect | undefined> {
        if (!to.meta?.feature) return;

        const feature = normalizeGateValue(to.meta.feature as string | string[], to);

        // Entitlement-aware rather than a plain boolean: an admin blocked by a plan or
        // addon is sent to the paywall, everyone else to a 404 exactly as before.
        return resolveEntitlementGate(to, feature);
    }
}

export default new Feature();
